import { createRef, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useSelector } from 'react-redux'

import { Box, Grid } from '@mui/material'
import { ModeEdit } from '@mui/icons-material'
import { ApplicationState } from '@/state/root.models'

import useDialog from '@/hooks/ui/use-dialog.hook'
import { DialogsEnum } from '@/enums'
import { IconButtonBg } from '@/theme/icon-button.theme'

import { useStyles } from './style'
import {
  PlayerAvatar,
  PersonalInfo,
  PlayerCardTabsComponent,
  usePlayerCardActions,
  PlayerBalance,
  DialogPersonalInfoForm,
} from './'
import { useWalletsActions } from '../wallets'

export default function PlayerCardModule() {
  const { getPlayerInfo, getPlayerRealBalance, resetPlayerCardInfo } =
    usePlayerCardActions()

  const { getWalletBonusBalance } = useWalletsActions()

  const { handleDialogAction } = useDialog()

  const [offset, setOffset] = useState(0)

  const { classes } = useStyles()

  const ref = createRef<HTMLDivElement>()

  const { brand } = useSelector(({ auth }: ApplicationState) => auth)

  const { playerId } = useParams<{ playerId: string }>()

  useEffect(() => {
    getPlayerInfo(playerId)
    getPlayerRealBalance(playerId)

    if (ref.current) {
      const { offsetTop } = ref.current
      setOffset(offsetTop - 24)
    }

    return () => {
      resetPlayerCardInfo()
    }
  }, [playerId, brand]) // eslint-disable-line

  useEffect(() => {
    if (!playerId) return

    getWalletBonusBalance({
      playerId,
    })
  }, [playerId, brand])

  return (
    <>
      <div ref={ref} />
      <Grid container flexWrap="nowrap" spacing={2} width="100%" m={0}>
        <Box className={classes.summary} top={offset}>
          <IconButtonBg
            aria-label="edit profile"
            onClick={() =>
              handleDialogAction({
                open: true,
                id: DialogsEnum.DIALOG_EDIT_PLAYER_DATA,
              })
            }
            size="small"
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              borderRadius: '50%',
            }}
          >
            <ModeEdit fontSize="inherit" />
          </IconButtonBg>
          <Box pt={5} sx={{ overflow: 'auto', height: '100%' }}>
            <PlayerAvatar />
            <PlayerBalance />
            <PersonalInfo />
          </Box>
        </Box>
        <Grid item width="calc(100% - 350px)" paddingRight={2}>
          <PlayerCardTabsComponent />
        </Grid>
      </Grid>
      <DialogPersonalInfoForm />
    </>
  )
}
